import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'

// Task Details Selectors
export const selectTask = (state: RootState) => state.task.tasks
export const selectFetchAssignedTask = (state: RootState) => state.task.assignedTask
export const selectSelectedTask = (state: RootState) => state.task.selectedTask

// Loading Selectors
export const selectLoadingFetchTasks = (state: RootState) => state.task.loadingFetchTasks
export const selectLoadingCreateTask = (state: RootState) => state.task.loadingCreateTask
export const selectLoadingUpdateTask = (state: RootState) => state.task.loadingUpdateTask
export const selectLoadingUpdateAssignedTask = (state: RootState) => state.task.loadingUpdateAssignedTask
export const selectLoadingFetchAssignedTask = (state: RootState) => state.task.loadingFetchAssignedTasks

// Error Selectors
export const selectErrorFetchTasks = (state: RootState) => state.task.errorFetchTasks
export const selectErrorCreateTask = (state: RootState) => state.task.errorCreateTask
export const selectErrorUpdateTask = (state: RootState) => state.task.errorUpdateTask
export const selectErrorFetchAssignedTasks = (state: RootState) => state.task.errorFetchAssignedTasks

export const selectPendingTaskCount = createSelector([selectFetchAssignedTask], (task) => {
  return task.filter((task) => task.status !== 'completed' && task.isArchived === false).length
})
